import { qsPost,qsPost1 } from './axios';

// login
export const userLogin = data => qsPost('https://utp.veryengine.cn/User/Login', data);

export const manMachine = data => qsPost('https://utp.veryengine.cn/User/manMachine', data);

export const BindPersonTag = (data) => qsPost('https://utp.veryengine.cn/Tag/BindPersonTag', data);

export const queryPersonTag = (data) => qsPost('https://utp.veryengine.cn/Tag/queryPersonTag', data);

export const currentSoftware = (data) => qsPost('https://utp.veryengine.cn/Tag/CurrentSoftware',data)

export const hasLogin = data => qsPost('https://utp.veryengine.cn/User/HasLogin', data);

export const signout = () => qsPost('https://utp.veryengine.cn/User/SignOut');

export const modelQuery = (data) => qsPost('https://assetstore.veryengine.cn/query', data);

export const modelImport = (data) => qsPost('https://assetstore.veryengine.cn/expo/export', data);
export const LoginInfo = (data) => qsPost('https://bigdata.veryengine.cn/LoginInfo', data);

export const cxUpdateSummary = (data) => qsPost1('http://app.cqgmy.edu.cn/api/applicationCenter/openapi/summary', data);
export const cxUpdateMission = (data) => qsPost1('http://app.cqgmy.edu.cn/api/applicationCenter/openapi/mission', data);
export const cxUpdateStep = (data) => qsPost1('http://app.cqgmy.edu.cn/api/applicationCenter/openapi/stepMultiple', data);

// export const cxUpdateSummary = (data) => qsPost1('https://vr.cqepc.edu.cn/api/applicationCenter/openapi/summary', data);
// export const cxUpdateMission = (data) => qsPost1('https://vr.cqepc.edu.cn/api/applicationCenter/openapi/mission', data);
// export const cxUpdateStep = (data) => qsPost1('https://vr.cqepc.edu.cn/api/applicationCenter/openapi/stepMultiple', data);
